import translationKeys from '@translationKeys'

export default {
  [translationKeys.MEETING_STATUS_HISTORY_TITLE_FOR_PREMIUM_USER]: 'Corporate history',
  [translationKeys.MEETING_STATUS_HISTORY_TITLE_FOR_FREE_USER]: 'Personal history',
  [translationKeys.MEETING_PENDING_STATUS_COUNT]: '{{count}} Pending',
  [translationKeys.MEETING_PENDING_STATUS]: 'Pending request',
  [translationKeys.MEETING_PAST_STATUS_COUNT]: '{{count}} Past Meetings',
  [translationKeys.MEETING_PAST_STATUS]: 'Past meeting',
  [translationKeys.MEETING_UPCOMING_STATUS]: '{{count}} Upcoming',
  [translationKeys.MEETING_DECLINED_STATUS]: '{{count}} Declined',
  [translationKeys.MEETING_CANCELED_STATUS]: '{{count}} Cancelled',
  [translationKeys.MEETING_INMAIL_STATUS_COUNT]: '{{count}} Contact',
  [translationKeys.CONTACT_STATUS_DETAILS]: 'Details',
  [translationKeys.MEETING_NO_RESPONSE_STATUS]: 'No response',
  [translationKeys.MEETING_NO_RESPONSE_STATUS_COUNT]: '{{count}} No response',
}
